module.exports = __webpack_public_path__ + "img/customers.13e31b9d.svg";